
export default {
  props: ["icon"],
};
